import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Container, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/auth';
import { Helmet } from 'react-helmet-async';

const Login = () => {
	const [email, setEmail] = useState<string>('');
	const [password, setPassword] = useState<string>('');
	const [error, setError] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(false);  // New loading state

	// Remeber the from address
    const location = useLocation()
    const to = location.state ? location.state.from as string || '/dashboard'  : '/dashboard';
  	const { loginUser } = useAuth();  // Access login function from AuthContext
  
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setIsLoading(true);  // Start loading
		
		try {
			await loginUser({email, password});
			navigate(to);  // Redirect
		} catch (err) {
			setError('Invalid login credentials');
		} finally {
			setIsLoading(false);  // Stop loading
		}
  };

  return (
    <Container className="mt-5"  style={{ maxWidth: '500px' }}>
      <Helmet>
        <title>Login - QuickyChat</title>
        <meta name="description" content="Login to your QuickyChat account to start chatting with your friends." />
        <meta name="keywords" content="QuickyChat, login, chat, messaging" />
      </Helmet>
      <h2 className="mb-4 text-center">Login</h2>
      
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formEmail" className="mb-3">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group controlId="formPassword" className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>
		<p>
			<Link to="/forgot-password" className='text-white'><strong>Forgot password</strong></Link>
		</p>

        {error && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}

        <Button variant="primary" type="submit" className="w-100">
			{isLoading && <Spinner animation="border" size="sm" />} Login
        </Button>
      </Form>
	  <p className="text-center mt-3">
		Don't have an account? <Link to="/register" className='text-white'><strong>Register here</strong></Link>
	</p>
    </Container>
  );
};

export default Login;
